export default ({
    name: 'Tooltip',
    props: ['descricao']
})